import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "name", label: "Organization Name" },
	{ key: "website", label: "Website" },
	{ key: "phoneNumber", label: "Business Phone" },
	{ key: "extension", label: "Extension" },
	{ key: "fax", label: "Fax" },
	{ key: "billingStreet", label: "Billing Street" },
	{ key: "billingCity", label: "Billing City" },
	{ key: "billingState", label: "Billing State" },
	{ key: "billingZipCode", label: "Billing Zip Code" },
	{ key: "overseaBillingAddress", label: "Oversea Billing Address" }, 
	{ key: "shippingStreet", label: "Shipping Street" },
	{ key: "shippingCity", label: "Shipping City" },
	{ key: "shippingState", label: "Shipping State" },
	{ key: "shippingPostalCode", label: "Shipping Zip Code" },
	{ key: "overseaShippingAddress", label: "Oversea Shipping Address" }, 
	{ key: "background", label: "Background" },
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];
export default function ContactExportForm(){
	return (<ExportForm columns = {EXPORT_COLUMNS}/>);
}